var linkUtils = require('js/linkUtils');

module.exports = function formatCommunityModel(model, cachedGroup) {
  if(cachedGroup) {
    model.bannerUrl = linkUtils.generateGroupBannerUrl(cachedGroup.bannerImageHash);
    model.formattedName = cachedGroup.name;
    model.imageUrl = linkUtils.generateGroupImageUrl(cachedGroup.logoImageHash);
    model.subDomain = cachedGroup.subDomain;
  }
  return model;
};



// WEBPACK FOOTER //
// ./app/assets/js/lib/formatCommunityModel.js